import { Chip } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function CopVariantBadge() {
    const { schedule } = useBoundContext()
    if (!schedule?._copVariant) return null

    return (
        <Chip
            label="CoP"
            size="small"
            color="info"
            variant="outlined"
            sx={{ ml: 0.5, height: 18, fontSize: "0.65rem", "& .MuiChip-label": { px: 0.5 } }}
        />
    )
}
